/**
 * L'agent, derrière l'Edge Function `agent`.
 *
 * Le client du navigateur porte la session : la fonction reçoit donc le JWT
 * du patron, et c'est avec lui — donc sous la RLS — que l'agent lit et écrit.
 */
import type { AgentAnswer, AgentGateway } from "@dker/core";
import { DomainError } from "@dker/core";
import type { DbClientFactory } from "../ports.js";
import { edgeFunctionErrorMessage } from "./documents.js";

export function createSupabaseAgentGateway(clientFor: DbClientFactory): AgentGateway {
  return {
    async ask(ctx, input) {
      const { data, error } = await clientFor(ctx).functions.invoke<{ data: AgentAnswer }>(
        "agent",
        {
          body: { question: input.question, history: input.history ?? [] },
          headers: { "x-request-id": ctx.requestId },
        },
      );
      if (error) {
        throw new DomainError(
          "conflict",
          await edgeFunctionErrorMessage(error as Parameters<typeof edgeFunctionErrorMessage>[0]),
          { function: "agent" },
        );
      }
      if (!data?.data) {
        throw new DomainError("conflict", "L'agent n'a rien répondu.", { function: "agent" });
      }
      return data.data;
    },
  };
}
